import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export enum Status {
    Active = 'ACTIVE',
    No_more_customers = 'NO_MORE_CUSTOMERS',
};

export enum Types {
    All = 'ALL',
    Admin_Company = 'ADMIN_COMPANY',
    Property_Company = 'PROPERTY_COMPANY',
    Cleaning_Company = 'CLEANING_COMPANY',
};

export enum Payment_status {
    ACTIVE = 'ACTIVE',
    INCOMPLETE = 'INCOMPLETE',
    INACTIVE = 'INACTIVE',
};

@Injectable({
    providedIn: 'root',
})
export class CompaniesService {

	constructor(
		public apiService: ApiService,
	) {
	}

  createCompany(params: {}, token: string) {

		var body: any;

		body = params;

		return this.apiService.post('/companies/create', body, token).pipe(response => response);

  }
	
  getCompany( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/companies/read', body, token).pipe(response => response);

  }

  updateCompany(params: {}, token: string) {

		var body: any;

		body = params;

		return this.apiService.post('/companies/update', body, token).pipe(response => response);

  }

	getCompanies( page: number, token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/companies/list?page=' + page, body, token).pipe(response => response);

  }

	getRentalCompanies( page: number, country: string, token: string ) {

		var body: any;

		body = {country: country};

		return this.apiService.get('/companies/listRental?page=' + page, body, token).pipe(response => response);

  }

	getCleaningCompanies( page: number, country: string, token: string ) {

		var body: any;

		body = {country: country};

		return this.apiService.get('/companies/listCleaning?page=' + page, body, token).pipe(response => response);

  }

  deleteLogo(token: string) {

		var body: any;

		body = {};

		return this.apiService.post('/companies/deleteLogo', body, token).pipe(response => response);

  }

}